import { FC } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import CreateEvidenceForm from "../Forms/CreateEvidenceForm";
import { Evidence } from "../evidence.types";
import {
  getCopyCreateOptions,
  getCopySourceData,
} from "./utils/copyEvidenceUtils";

type CopyEvidenceModalProps = {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onCancel: () => void;
  sourceEvidence: Evidence;
  includeCaseField?: boolean;
  navigateToItem?: boolean;
};

const CopyEvidenceModal: FC<CopyEvidenceModalProps> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  sourceEvidence,
  includeCaseField = false,
  navigateToItem = false,
}) => {
  const handleSubmit = () => {
    onSubmit?.();
    onClose();
  };

  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  const createOptions = getCopyCreateOptions(sourceEvidence);
  const isChildCopy = createOptions !== undefined;
  const defaultFormData = getCopySourceData(sourceEvidence, isChildCopy);

  return (
    <>
      <Modal open={show} onClose={onClose}>
        <CreateEvidenceForm
          width={700}
          onSubmit={handleSubmit}
          formTitle={isChildCopy ? "Copy Child Evidence Item" : undefined}
          description={
            isChildCopy
              ? `This will create a new child item under ${sourceEvidence.parent_name}.`
              : undefined
          }
          submitText={isChildCopy ? "Copy Child Item" : "Copy Evidence"}
          createOptions={createOptions}
          onCancel={handleCancel}
          defaultFormData={defaultFormData}
          // A child must stay in its parent's case; the API does not enforce it.
          includeCaseField={isChildCopy ? false : includeCaseField}
          navigateToItem={navigateToItem}
        />
      </Modal>
    </>
  );
};

export default CopyEvidenceModal;
